export function handoutPreviewCacheKey(handoutId) {
  return `handout:${handoutId}:preview`
}

export function saveHandoutPreviewCache(handoutId, payload) {
  if (!handoutId) return
  try {
    sessionStorage.setItem(handoutPreviewCacheKey(handoutId), JSON.stringify({
      title: payload && payload.title ? payload.title : '',
      contentHtml: payload && payload.contentHtml ? payload.contentHtml : '',
      updatedAt: Date.now()
    }))
  } catch (e) {}
}

export function loadHandoutPreviewCache(handoutId) {
  if (!handoutId) return null
  try {
    const raw = sessionStorage.getItem(handoutPreviewCacheKey(handoutId))
    return raw ? JSON.parse(raw) : null
  } catch (e) {
    return null
  }
}

export function extractHandoutFromResponse(data) {
  if (!data || typeof data !== 'object') return {}
  if (data.handout && typeof data.handout === 'object') return { ...data.handout }
  if (data.title != null || data.contentHtml != null) return { ...data }
  return {}
}
